@switch (nachrichtState) {

    @case (NachrichtStateEnum.FORM) {
        <kokos-nachricht-form
                scrollIntoView
                [nachrichtPayload]="nachrichtPayload"
                [anliegenName]="anliegenName"
                [betreffEditable]="true"
                [subanliegenName]="subanliegenName"
                [showUpload]="anhangErlaubt"
        ></kokos-nachricht-form>
    }

}
